import IdIcon from "app/components/Icons/IdIcon";
import CustomTooltip from "app/components/Tooltip";
import React from "react";

interface CustomProps {
  value: string;
}

const TicketId: React.FC<CustomProps> = ({ value }) => {
  return (
    <>
      <button className="flex items-center justify-between w-full p-[6px] rounded-md hover:bg-[#F4F5F7] rounded-[4px] data-[state=open]:border-[#79808A] data-[state=open]:outline-[#79808A] data-[state=open]:border-[1px] border-[#79808A] ">
        <CustomTooltip text="Ticket ID" className="flex items-center ">
          <div className="flex items-center gap-1 w-full">
            <IdIcon size={16}/>
            <span className="text-xs font-normal text-secondary">{value}</span>
          </div>
        </CustomTooltip>
      </button>
    </>
  );
};

export default TicketId;
